import { useReduxState } from 'hooks';
import { Button } from 'components/common';

interface Props {
  first?: boolean;
  index: number;
  last?: boolean;
  locked?: boolean;
  move: (index: number, direction: 1 | -1) => void;
  remove: (index: number) => void;
}

const HomePageSettingsModulesControls = ({
  first = false,
  index,
  last = false,
  locked = false,
  move,
  remove
}: Props) => {
  const { messages } = useReduxState();

  const handleMoveUp = () => move(index, -1);

  const handleMoveDown = () => move(index, 1);

  const handleRemove = () => remove(index);

  return (
    <div>
      {locked ? (
        <Button
          category="lighter"
          disabled={true}
          icon="lock"
          isRounded={true}
          tooltip={messages.homePageModuleLocked}
        />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <Button
            category="lighter"
            disabled={first}
            icon="arrow-up"
            isRounded={true}
            onClick={handleMoveUp}
            tooltip={messages.commonMoveUp}
          />
          <Button
            category="lighter"
            disabled={last}
            icon="arrow-down"
            isRounded={true}
            onClick={handleMoveDown}
            tooltip={messages.commonMoveDown}
          />
          <Button
            category="lighter"
            icon="trash-alt"
            isRounded={true}
            onClick={handleRemove}
            tooltip={messages.commonRemove}
          />
        </div>
      )}
    </div>
  );
};

export default HomePageSettingsModulesControls;
